"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Quote", {
    enumerable: true,
    get: function() {
        return Quote;
    }
});
var _react = _interop_require_default(require("react"));
var _components = require("@cmpsr/components");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
var Quote = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        flexDirection: "column",
        gap: "1.5rem",
        maxWidth: "52.5rem",
        margin: "0 auto"
    }, props));
};
var QuoteText = function(props) {
    return _react.default.createElement(_components.Text, _object_spread({
        variant: "text-body-display-L"
    }, props));
};
Quote.Title = QuoteText;
var QuoteAuthorAvatar = function(props) {
    return _react.default.createElement(_components.Avatar, _object_spread({
        backgroundColor: "primary-disabled",
        color: "text-secondary",
        size: "m"
    }, props));
};
var QuoteAuthorName = function(props) {
    return _react.default.createElement(_components.TextPairing, _object_spread({
        variant: "textpairing-body-bold-meta"
    }, props));
};
QuoteAuthorName.Label = _components.TextPairing.Label;
QuoteAuthorName.SubLabel = _components.TextPairing.SubLabel;
var QuoteAuthor = function(props) {
    return _react.default.createElement(_components.Flex, _object_spread({
        gap: "0.75rem"
    }, props));
};
QuoteAuthor.Avatar = QuoteAuthorAvatar;
QuoteAuthor.Name = QuoteAuthorName;
Quote.Author = QuoteAuthor;
